import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "admin_billing/";
const getCommissionEarned = (params) => axios.get(`${baseURL}commission_earned?${params}`);
const getBillingStats = (params) => axios.get(`${baseURL}stats?${params}`);
const downloadBillingDetails = (params) => axios.get(`${baseURL}download_csv?${params}`);


export {
    getCommissionEarned,
    getBillingStats,
    downloadBillingDetails
}